export default __webpack_public_path__ + "2019 Controlled Growth of the Noncentrosymmetric Zn(3-ptz)2 and Zn(OH)(3-ptz) Metal–Organic Frameworks.pdf";